import React, { useState } from 'react';
import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';

export type PopoverItem = {
    title: string;
    content: string;
};

export type IconTextPopoverProps = {
    icon?: React.ElementType;
    text: string;
    items: PopoverItem[];
    isDisabled?: boolean;
    placement?: TooltipPlacement;
};

export const IconTextPopover: React.FC<IconTextPopoverProps> = ({
    icon: IconComponent,
    text,
    items,
    isDisabled = false,
    placement = 'bottomLeft',
}) => {
    const [open, setOpen] = useState(false);

    const content = (
        <div
            style={{ maxHeight: '320px', overflowY: 'auto', width: '248px', overflowX: 'auto' }}
            className="bg-backgroundGreyAlt rounded p-2"
        >
            {items.map((item, index) => (
                <div key={index} className="pb-3 font-xs">
                    <strong>{item.title}</strong>
                    <p style={{ margin: 0 }}>{item.content}</p>
                </div>
            ))}
        </div>
    );

    return (
        <Popover
            content={content}
            trigger="click"
            open={!isDisabled && open}
            onOpenChange={(val) => !isDisabled && setOpen(val)}
            overlayClassName={'icon-text-popover'}
            placement={placement}
        >
            <button
                type="button"
                onClick={(e) => {
                    if (!isDisabled) setOpen(!open);
                    e.stopPropagation();
                }}
                className={`flex items-center gap-1 rounded text-greyFont px-2 py-0.5 ${
                    open ? 'bg-backgroundGreyAlt9' : ''
                } ${isDisabled ? 'cursor-default' : 'cursor-pointer'}`}
            >
                {IconComponent && <IconComponent />}
                <span>{text}</span>
            </button>
        </Popover>
    );
};
